// let title;
let results;
let input;
let token;
// Add an initial request body.
let request = {
  input: "",
  locationRestriction: {
    west: 101.22,
    north: 3.39,
    east: 101.94,
    south: 2.81,
  },
  includedRegionCodes: "my",
  origin: { lat: 3.1144294519215454, lng: 101.58858900884887 },
  // includedPrimaryTypes: ["restaurant"],
  language: "en-US",
  region: "my",
};

async function init_address_autocomplete() {
  token = new google.maps.places.AutocompleteSessionToken();
  // title = document.getElementById("title");
  results = document.getElementById("address-auto-complete-results");
  input = document.getElementById("recipient-address1");
  input.addEventListener("input", makeAcRequest);
  request = refreshToken(request);
}

async function makeAcRequest(input) {
  // Reset elements and exit if an empty string is received.
  if (allow_auto_complete){
    if (input.target.value == "") {
      // title.innerText = "";
      results.replaceChildren();
      return;
    }
  
    // Add the latest char sequence to the request.
    request.input = input.target.value + " Malaysia";
  
    // Fetch autocomplete suggestions and show them in a list.
    // @ts-ignore
    const { suggestions } =
      await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
        request,
      );
  
    // title.innerText = 'Query predictions for "' + request.input + '"';
    // Clear the list first.
    results.replaceChildren();
  
    for (const suggestion of suggestions) {
      const placePrediction = suggestion.placePrediction;
      // Create a link for the place, add an event handler to fetch the place.
      const a = document.createElement("a");
  
      a.addEventListener("click", () => {
        onPlaceSelected(placePrediction.toPlace());
      });
      a.innerText = placePrediction.text.toString();

      // console.log(placePrediction.mainText.toString())
      // console.log(placePrediction.secondaryText.toString())
  
      // Create a new list element.
      const li = document.createElement("li");
  
      li.appendChild(a);
      results.appendChild(li);
    }
  } else {
    console.log("auto_complete disallowed")
  }
}

// Event handler for clicking on a suggested place.
async function onPlaceSelected(place) {
  await place.fetchFields({
    fields: ["displayName", "formattedAddress","adrFormatAddress","addressComponents","postalAddress"],
  });

  console.log(place.displayName)
  console.log(place.formattedAddress)
  console.log(place.adrFormatAddress)
  console.log(place.addressComponents)
  console.log(place.postalAddress)


  let address_1
  let postal_code
  let locality

  for (let c of place.addressComponents) {
    let key = 'Eg'
    let value_key = ''
    let keys = Object.keys(c)
    for (let i = 0; i < keys.length; i++){
      if (Array.isArray(c[keys[i]])){
        key = keys[i]
      } else if (value_key == ''){
        value_key = keys[i]
      }
    }

    console.log('key is '+key)
    console.log('value_key is '+value_key)
    if (c[key][0] == 'locality'){
      locality = c[value_key]
    } else if (c[key][0] == 'postal_code'){
      postal_code = c[value_key]
    }
  }

  let address_without_postal_code = place.formattedAddress.split(postal_code)[0]

  console.log(address_without_postal_code)
  console.log(place.displayName)
  
  if (address_without_postal_code.includes(place.displayName)){
    address_1 = place.formattedAddress.split(postal_code)[0]
  } else {
    address_1 = place.displayName + ", " + place.formattedAddress.split(postal_code)[0]
  }

  document.getElementById('recipient-address1').value = address_1
  document.getElementById('recipient-city').value = locality
  document.getElementById('recipient-postcode').value = postal_code
  
  // let placeText = document.createTextNode(
  //   place.displayName + ": " + place.formattedAddress,
  // );

  results.replaceChildren();
  // title.innerText = "Selected Place:";
  // input.value = "";
  refreshToken(request);
}

// Helper function to refresh the session token.
async function refreshToken(request) {
  // Create a new session token and add it to the request.
  token = new google.maps.places.AutocompleteSessionToken();
  request.sessionToken = token;
  return request;
}

window.init_address_autocomplete = init_address_autocomplete;